import dayjs from 'dayjs'

const getExpiresInMiliseconds = () => {
  const now = dayjs()
  const midnight = dayjs().add(1, 'day').startOf('day')
  return midnight.diff(now, 'milliseconds', true)
}

export const AuthUtils = {
  getExpiresInMiliseconds,
}
